import { FetchAllLicenses } from '@account-users/account/state/licenses/licenses.actions';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Account, SectionDomain, SectionDomainSetting } from '../../models';
import {
  accountDomainSettingActions,
  getAccountsActions,
  sectionDomainActions,
} from '../../store/actions/domain-settings-edit.actions';
import { getDomainSettingsAction } from '../../store/actions/domain-settings.actions';
import {
  getSelectedAccountDomainName,
  getSelectedAccountId,
  getSelectedAccountToggle,
  getSelectedSectionsDomains,
  State,
} from '../../store/reducers';

import { PrivateDomainPresenter } from '../private-domain-presenter/private-domain.presenter';

@Component({
  providers: [PrivateDomainPresenter],
  selector: 'apsis-back-office-private-domain-add',
  templateUrl: './private-domain-add.component.html',
  styleUrls: ['./private-domain-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateDomainAddComponent implements OnInit {
  public accounts$: Observable<Account[]>;
  public selectedAccount$: Observable<string>;
  public selectedAccountToggle$: Observable<boolean>;
  public selectedAccountDomainName$: Observable<string>;
  public selectedSectionsDomains$: Observable<SectionDomainSetting[]>;
  public sections$: Observable<SectionDomain[]>;
  public enableSave$: Observable<boolean>;

  constructor(
    private readonly privateDomainPresenter: PrivateDomainPresenter,
    private readonly router: Router,
    private readonly store: Store<State>,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(accountDomainSettingActions.clear());

    this.accounts$ = this.privateDomainPresenter.getAccounts();
    this.selectedAccount$ = this.store.pipe(select(getSelectedAccountId));
    this.selectedAccountDomainName$ = this.store.pipe(
      select(getSelectedAccountDomainName),
    );
    this.selectedAccountToggle$ = this.store.pipe(
      select(getSelectedAccountToggle),
    );
    this.selectedSectionsDomains$ = this.store.pipe(
      select(getSelectedSectionsDomains),
    );

    this.sections$ = this.privateDomainPresenter.getSections();
    this.enableSave$ = this.privateDomainPresenter.enableSave();
    this.store.dispatch(getAccountsActions.get({}));
    this.store.dispatch(getDomainSettingsAction.get());
  }

  selectAccount(accountId: string) {
    this.store.dispatch(accountDomainSettingActions.setAccount({ accountId }));
    this.store.dispatch(new FetchAllLicenses({ accountId }));
  }

  selectAccountDomainName(accountDomainName: string) {
    this.store.dispatch(
      accountDomainSettingActions.setAccountDomainName({ accountDomainName }),
    );
  }

  toggleDomain(enabled: boolean) {
    this.store.dispatch(accountDomainSettingActions.toggleDomain({ enabled }));
  }

  addSectionDomain(sectionDomain: SectionDomainSetting) {
    this.store.dispatch(
      sectionDomainActions.addSectionDomain({ section: sectionDomain }),
    );
  }

  removeSectionDomain(sectionId: string) {
    this.store.dispatch(
      sectionDomainActions.removeSectionDomain({ sectionId }),
    );
  }

  selectSectionDomain(sectionId: string) {
    this.store.dispatch(
      sectionDomainActions.selectSectionDomain({ sectionId }),
    );
  }

  cancel() {
    this.router.navigate(['/private-domain']);
    this.store.dispatch(accountDomainSettingActions.clear());
  }

  save() {
    this.store.dispatch(accountDomainSettingActions.save());
  }
}
